import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

function WelcomeModal() {
  const dispatch = useDispatch();

  const close = () => dispatch({ type: "CLOSE_WELCOME_MODAL" });

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1050,
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backdropFilter: "brightness(25%)",
      }}
      className="d-flex justify-content-center align-items-center"
    >
      <div className="bg-light d-flex flex-column align-items-center p-4 w-50">
        <p style={{ fontSize: "0.9rem" }} className="mb-2 fw-bold">
          Welcome! New Here?
        </p>
        <p className="mb-1" style={{ fontSize: "0.8rem" }}>
          On January 2022, we started our journey to become Full Stack developers. We participated
          in Hack Academy's Coding Bootcamp, which was an intensive 3 months long course where we
          learnt about Front and Back End development.
        </p>
        <p className="mt-0" style={{ fontSize: "0.8rem" }}>
          SuperPower is our final project, where we put everything we have learnt in practice to create a
          fully functional E-Commerce.
        </p>
        <p style={{ fontSize: "0.8rem" }}>
          If you would like to learn more about who we are and this project, click below.
        </p>
        <Link
          to="/about"
          className="welcome-modal-button text-center"
          style={{ color: "white" }}
          onClick={close}
        >
          MORE ABOUT THIS PROJECT
        </Link>
        <p style={{ fontSize: "0.8rem" }} className="mb-2 mt-3">
          Or, if you prefer:
        </p>
        <a className="welcome-modal-button text-center" style={{ color: "white" }} onClick={close}>
          JUST LET ME NAVIGATE THROUGH THE SITE
        </a>
        <p style={{ fontSize: "0.8rem" }} className="mb-0 mt-3 text-center">
          (You can visit the "about us" page anytime you like.)
        </p>
      </div>
    </div>
  );
}

export default WelcomeModal;
